let config = null

export async function loadConfig() {
    const res = await fetch("/config.json", {cache: "no-store"})
    if (!res.ok) throw new Error("config.json introuvable")
    config = await res.json()
    return config
}

export function getConfig() {
    if (!config) throw new Error("Config non chargée")
    return config
}
